module.exports = __webpack_public_path__ + "media/images/img-travel-4-2b064cd7.jpg";